<template>
    <a-modal
        :visible="visible"
        title="Unggah Suggestion Toko Lelang"
        @cancel="handleModalCancel"
        width="80%"
        :destroy-on-close="true"
        :footer="null">

        <AForm
            ref="formRef"
            class="myform"
            @submit.prevent="btnUploadFile()"
            :wrapper-col="{ span: 14 }"
            :scroll-to-first-error="true">

            <a-row class="form-row">
                <a-col :sm="24">
                    <a-form-item
                        label="Unggah Dokumen"
                        label-align="left"
                        :label-col="{ sm: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 4 } }"
                        has-feedback>
                        <ATooltip
                            title="Template Unggah Suggestion Toko Lelang bisa didapatkan dari Hasil Download menu Suggestion Toko Lelang"
                            placement="topLeft">
                            <AInput
                                v-if="state.isForm"
                                type="file"
                                required
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                @change="onFileChange"/>
                        </ATooltip>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row class="form-row mb-4">
                <ACol :sm="4"/>
                <a-col :sm="20">
                    <ASpace>
                        <a-button
                            type="primary"
                            html-type="submit"
                            :loading="state.form.loading">Upload</a-button>
                        <!-- <AButton
                            @click="btnDownloadTemplate()"
                            :loading="state.loadingTemplate">Unduh Template</AButton> -->
                    </ASpace>
                </a-col>
            </a-row>
        </AForm>

        <AAlert
            v-if="errorMessage"
            type="error"
            :message="errorMessage"
            banner
            closable
            @close="errorMessage = null"/>

        <br>

        <AForm
            ref="formRefTable"
            class="myform"
            :model="form"
            :rules="state.rules"
            @finish="handleSubmitOk"
            :wrapper-col="{ span: 14 }"
            :scroll-to-first-error="true">

            <MdTable
                :columns="state.columns"
                :data-source="state.data"
                row-key="suggestion_id"
                :row-selection="rowSelection"
                size="small"
                :scroll="{ x: 'calc(700px + 80%)', y: 600 }"
                :loading="state.loading">
                <template #tags="{ record }">
                    <a-tag :color="record.errors.length == 0 ? 'green' : 'volcano'">
                    <template #icon>
                        <template v-if="record.errors.length == 0"> <CheckCircleOutlined /> Ya </template>
                        <template v-else>
                            <APopover trigger="click">
                                <template #content>
                                    <AList size="small" :data-source="record.errors">
                                        <template #renderItem="{ item }">
                                            <AListItem>{{ item }}</AListItem>
                                        </template>
                                    </AList>
                                </template>
                                <CloseCircleOutlined /> Tidak
                            </APopover>
                        </template>
                    </template>
                    </a-tag>
                </template>

                <template
                    #upload="{ index, text }">
                    <AFormItem
                        :name="['files', index, 'file']">
                        <AUpload
                            accept="application/pdf"
                            :before-upload="file => listenBeforeUpload(file, index)"
                            :file-list="text.file"
                            :max-count="1"
                            :disabled="!text.isUpload">
                            <ATooltip
                                :title="text.isUpload ? state.approve_notes[text.action] : ''">
                                <AButton
                                    :disabled="!text.isUpload">
                                    <UploadOutlined/>Pilih File
                                </AButton>
                            </ATooltip>
                        </AUpload>
                    </AFormItem>

                    <iframe
                        v-if="text.image_url"
                        :src="text.image_url"
                        width="100%"/>
                </template>
            </MdTable>

            <ARow class="form-row mt-4" type="flex" justify="end">
                <ASpace>
                    <AButton @click="handleModalCancel">Batal</AButton>
                    <AButton
                        type="primary"
                        html-type="submit"
                        :loading="state.loading">Submit</AButton>
                </ASpace>
            </ARow>
        </AForm>

         <AModal
            v-model:visible="state.result.isShow"
            title="Result"
            @cancel="handleShowCancel"
            @ok="handleShowCancel">
            <template #footer>
                <AButton key="back" type="primary" @click="handleShowCancel">OK</AButton>
            </template>
            <AAlert type="success" :message="`Approve: ${state.result.valid}`"></AAlert>
            <AAlert type="error">
                <template #message>
                {{ `Reject: ${state.result.failed}` }}

                <p
                    v-for="(item, index) in state.result.data_reject"
                    :key="index">{{ item.title }}</p>
                </template>
            </AAlert>
            <AAlert
                v-has-role="[ROLE_TSO]"
                type="error">
                <template #message>
                {{ `Delete: ${state.result.delete}` }}

                <p
                    v-for="(item, index) in state.result.data_delete"
                    :key="index">{{ item.title }}</p>
                </template>
            </AAlert>
        </AModal>

    </a-modal>
</template>
<script>
import {
    defineComponent,
    nextTick,
    reactive,
    ref,
    computed,
} from 'vue'
import apiClient from '@/services/axios'
import { CheckCircleOutlined, CloseCircleOutlined, UploadOutlined } from '@ant-design/icons-vue'
import { Modal, message } from 'ant-design-vue'
import Form from 'vform'
import moment from 'moment'
import {
    ROLE_TSO,
    ROLE_SPC,
    hasRoles,
    hasColumnRoles,
} from '@/helpers'
import dbIndexClient from '@/helpers/dbIndexClient'

export default defineComponent({
    components: {
        CheckCircleOutlined,
        CloseCircleOutlined,
        UploadOutlined,
    },
    props: {
        visible: [Boolean],
    },
    emits: ['btnUploadFileConversionPoint', 'update:visible'],
    setup(props, { emit }) {
        const errorMessage = ref()

        const formRef = ref();
        const formRefTable = ref();

        const form = reactive(new Form({
            files: [],
        }))

        const dbClient = dbIndexClient.initDB('storages')

        const state = reactive({
            columns: hasColumnRoles([
                {
                    title: 'Valid?',
                    dataIndex: 'valid',
                    slots: {
                        customRender: 'tags',
                    },
                },
                {
                    title: 'Action',
                    dataIndex: 'action',
                },
                {
                    title: 'Upload',
                    width: 230,
                    key: 'upload',
                    slots: { customRender: 'upload' },
                },
                {
                    title: 'Kategori',
                    dataIndex: 'header',
                },
                {
                    title: 'Note',
                    dataIndex: 'note',
                },
                {
                    title: 'Periode',
                    dataIndex: 'periode',
                },
                {
                    title: 'Region',
                    dataIndex: 'regional',
                },
                {
                    title: 'ID Toko',
                    dataIndex: 'customer_code',
                },
                {
                    title: 'Nama Toko',
                    dataIndex: 'customer_name',
                },
                {
                    title: 'Alamat',
                    dataIndex: 'address',
                },
                {
                    title: 'Area',
                    dataIndex: 'area',
                },
                {
                    title: 'Kota',
                    dataIndex: 'kota',
                },
                {
                    title: 'Provinsi',
                    dataIndex: 'provinsi',
                },

                {
                    title: 'SSM',
                    dataIndex: 'ssm',
                },
                {
                    title: 'ASM',
                    dataIndex: 'sm',
                },
                {
                    title: 'TSO',
                    dataIndex: 'am',
                },
                {
                    title: 'Distributor Mapping',
                    dataIndex: 'distributor_mapping',
                },
                {
                    title: 'Average Volume Toko (2 Bulan)',
                    dataIndex: 'avg_volume',
                },
                {
                    title: 'Status',
                    dataIndex: 'status',
                },
                {
                    title: 'Catatan TSO',
                    dataIndex: 'catatan_am',
                },
            ], {
                upload: [ROLE_TSO],
            }, 'key'),
            rules: {
                files: [],
            },
            rule_references: {
                file: [
                    {
                        required: true,
                        message: "File tidak boleh kosong!",
                    },
                ],
            },
            endpoint: {
                current: '/api/report-lelang/upload-approval',
                template: '/api/visit-plan/unduh-template',
            },
            data: [],
            loading: false,
            meta: {
                per_page: 10,
                page: 1,
                total: 0,
            },
            selectedRowKeys: [],
            selectedRows: [],
            result: {
                isShow: false,
                data_reject: [],
                data_delete: [],
                valid: '',
                failed: '',
                delete: '',
            },
            form: {
                loading: false,
                files: null,
                file: null,
            },
            isForm: true,
            approve_notes: {
                approve: 'Wajib mencantumkan Berita Acara beserta Invoice Piutang Distributor  (format PDF).',
                reject: 'Wajib mencantumkan Berita Acara beserta Invoice Piutang Distributor  (format PDF).',
                delete: 'Wajib mencantumkan Berita Acara beserta foto yang dilengkapi dengan Geotagging dan Time Stamp (format PDF).',
            },
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
        }

        const onFileChange = (e) => {
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) return
            state.form.file = files[0]
        }

        const rowSelection = computed(() => {
            return {
                selectedRowKeys: state.selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    state.selectedRowKeys = selectedRowKeys
                    state.selectedRows = selectedRows
                },
                getCheckboxProps: record => ({
                    disabled: record.errors.length > 0,
                }),
            }
        })

        const btnUploadFile = async () => {
            // validation form
            await formRef.value.validate()
                .catch(() => { });
            
            state.form.loading = true
            state.rules.files = []
            form.files = []

            const form_data = new FormData()

            form_data.append('file', state.form.file)

            apiClient.post(state.endpoint.current, form_data)
                .then(({ data }) => {
                    data.forEach(item => {
                        item.isUpload = !(item.errors.length > 0)
                        if (item.action == 'approve') {
                            item.isUpload = item.isUpload && item.header == 'Bad Debt' // only required delete and reject action or category 1 (Bad Debt)
                        }

                        // Clone rule_references dan update nilai required berdasarkan isUpload
                        const updatedRuleReferences = {
                            file: [
                                {
                                    ...state.rule_references.file[0], // copy properti lainnya (misal message)
                                    required: item.isUpload, // set nilai required dinamis
                                },
                            ],
                        }

                        // Push ke state.rules.files dan form.files
                        state.rules.files.push(Object.assign({}, updatedRuleReferences))
                        form.files.push(Object.assign({}, { file: null }))
                    })

                    state.data = data

                    // load files storage from indexDB
                    loadFilesIndexDB()
                })
                .catch(async error => {
                    errorMessage.value = null

                    if (error.response && error.response.status !== 500) {
                        const { status, statusText } = error.response
                        const message = JSON.parse(await error.response.data.text()).message
                        errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                    }

                    if (error.response && error.response.status === 500) {
                        const { status, statusText } = error.response
                        const message = error.response.data.message
                        errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                    }

                    message.error('Gagal mengungah!')
                })
                .finally(() => {
                    state.form.loading = false

                    state.isForm = false
                    nextTick().then(() => {
                        state.isForm = true
                    })
                })
        }

        const handleSubmitOk = async () => {
            // validation form
            await formRefTable.value.validate()
                .catch(() => { });

            const payloads = new FormData()

            state.selectedRows.forEach((item, index) => {
                payloads.append(`simpan[${index}][action]`, item.action)
                payloads.append(`simpan[${index}][suggestion_id]`, item.suggestion_id)
                payloads.append(`simpan[${index}][note]`, item.note)
                payloads.append(`simpan[${index}][status_approval]`, item.status_approval)
                payloads.append(`simpan[${index}][valid]`, item.valid)
                payloads.append(`simpan[${index}][header]`, item.header)
    
                if (item.image) {
                    payloads.append(`simpan[${index}][image]`, item.image)
                }
            })

            state.result.data = []
            errorMessage.value = null
            state.loading = true

            apiClient
                .post(state.endpoint.current, payloads)
                .then(({ data }) => {
                    if (Array.isArray(data) && data.length === 0) {
                        message.warning('Tidak ada data!, pastikan sudah memilih datanya')
                        return
                    }

                    state.result.isShow = true

                    data.forEach((item, index) => {
                        if ((item.action == "reject" && !item.success) || (item.errors)) {
                            item.errors.forEach((v, i) => {
                                state.result.data_reject.push({
                                    title: v,
                                    key: i,
                                })
                            })
                        } else if ((item.action == "reject" && item.success) || (item.errors)) {
                            state.result.failed = item.message
                        } else if ((item.action == "delete" && !item.success) || (item.errors)) {
                            item.errors.forEach((v, i) => {
                                state.result.data_delete.push({
                                    title: v,
                                    key: i,
                                })
                            })
                        } else if ((item.action == "delete" && item.success) || (item.errors)) {
                            state.result.delete = item.message
                        } else if ((item.action == "approve" && item.success)) {
                            state.result.valid = item.message
                        }
                    })

                    // clear selected row
                    state.selectedRowKeys = []
                    state.selectedRows = []
                    state.data = []

                    // clear indexDB storage
                    dbClient.store('files').clear()
                    
                    emit('success', data)
                })
                .catch(async error => {
                    errorMessage.value = null
                    if (error.response) {
                        const { status, statusText } = error.response
                        const message = error.response.data.message
                        errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                    }
                })
                .finally(() => {
                    state.loading = false
                })
        }

        const btnDownloadTemplate = async () => {
            state.loadingTemplate = true

            apiClient
                .post(state.endpoint.template, null, {
                    params: {
                        _export: 'xls',
                    },
                    responseType: 'blob',
                    headers: {},
                })
                .then(response => {
                    if (response === undefined) {
                        errorMessage.value = `Kode error 500, No response from server`
                        return
                    }
                    const url = URL.createObjectURL(
                        new Blob([response.data], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        }),
                    )
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', `Master-Visit-Plan_${moment().format('DDMMYY_HHmm')}.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                })
                .catch(async error => {
                    errorMessage.value = null
                    if (error.response) {
                        const { status, statusText } = error.response
                        const message = JSON.parse(await error.response.data.text()).message
                        errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                    }
                })
                .finally(() => {
                    state.loadingTemplate = false
                })
        }

        const handleShowCancel = () => {
            state.result.isShow = false
        }

        const listenBeforeUpload = async (file, index) => {
            let first = state.data.find((item, i) => i == index)
            let url = URL.createObjectURL(file)

            if (first && url) {
                first.image_url = url
                first.image = file
                form.files[index].file = file

                // save file in indexDB
                const findFile = await dbClient.store('files').find(x => x.id === first.suggestion_id)
                const fileSave = {
                    id: first.suggestion_id,
                    uid: file.uid,
                    name: file.name,
                    type: file.type,
                    blob: file.slice(),
                }

                if (findFile) {
                    // update file
                    dbClient.store('files').update(fileSave)
                } else {
                    // create new file
                    dbClient.store('files').create(fileSave)
                }
            }

            return false
        }

        const loadFilesIndexDB = async () => {
            state.data.forEach(async (item, index) => {
                // set file blob from dbIndex
                const file = await dbClient.store('files').find(x => x.id === item.suggestion_id)

                if (file) {
                    const blob = new Blob([file.blob], { type: file.type })
                    const url = URL.createObjectURL(blob)

                    item.image_url = url
                    item.image = file.blob
                    form.files[index].file = blob
                }
            })
        }

        return {
            errorMessage,
            state,
            formRef,
            formRefTable,
            form,
            btnUploadFile,
            handleSubmitOk,
            handleModalCancel,
            onFileChange,
            rowSelection,
            btnDownloadTemplate,
            handleShowCancel,
            listenBeforeUpload,
            // only role
            ROLE_TSO,
            ROLE_SPC,
            hasRoles,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
